import {Button,CircularProgress, Divider} from '@material-ui/core';
import { Grid, TextField, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import * as userActions from '../actions/authenticationActions';
import {useHistory} from 'react-router-dom';
import {LOGIN_ADTHRIVE_TEXTS} from '../utility';


const UiInput = makeStyles({
  root : {
    "& .MuiInputBase-input": {
      borderRaduis: '4px',
      border: 'none',
      boxShadow: '0px 1px 6px #7784945e',
      padding: '5px 10px',
      margin: 0
  },
  "& .MuiInputBase-input:focus": {
      boxShadow:'none',
      outline:'none'
  },
  }
});


function LoginAdthriveForm(props){
    const uiInputClass = UiInput().root;
    const dispatch = useDispatch();
    const history = useHistory();
    const [sEmail, setEmail] = React.useState();
    const [sPassword, setPassword] = React.useState();
    const [loginInProgress, setLoginInProgress] = React.useState(false);

    const loadBriefView = () => {
      history.push({
        pathname: '/load_brief',
        state: { openSnackbar: props.openSnackbar }
      });
    }

    const loadLoginLegacyView = () => {
      history.push({
        pathname: '/login_legacy'
      });
    }

    const loginAdThrive = () => {
      dispatch(userActions.loginAdthriveUser(setLoginInProgress, () => {
        history.push('/choose_site');
        window.AP.tanalytics.track('User Login');
      }));
    }
    
    return(
        <Grid container xs="12" md="12" direction="column" alignItems="center" justify="center" spacing={1} style={{paddingTop: '200px', position: 'absolute'}}>
            <Grid item>
              <Typography variant="h6" color="primary" style={{fontWeight:'bold',textAlign:'center'}}>{LOGIN_ADTHRIVE_TEXTS.SIGN_IN_TEXT}</Typography>
            </Grid>
          <Grid item alignItems="center" justify="center" style={{textAlign:'center'}}>
            <Button variant="contained" color="primary" size="small" disabled={loginInProgress} onClick={loginAdThrive}>
             {(!loginInProgress) ? "Sign in with Google" : <CircularProgress size={24} />}   
            </Button>
          </Grid>
          <Grid item style={{textAlign: 'center'}}>
            <Divider style={{marginTop: '10px', marginBottom: '10px'}}/>
            <Grid item>
              <a variant="subtitle2" onClick={loadBriefView} className="link" style={{textDecoration:'underline',cursor:'pointer'}}>{LOGIN_ADTHRIVE_TEXTS.LOAD_BRIEF_BUTTON_TEXT}</a>
            </Grid>
            <Grid item style={{marginTop: '6px'}}>
              <a variant="subtitle2" onClick={loadLoginLegacyView} className="link" style={{textDecoration:'underline',cursor:'pointer', color: '#7b97b1',display:'none'}}>Log in (Legacy)</a>
            </Grid>
          </Grid>
          <Grid item>
            <div style={{"margin":"20px","backgroundColor":"white","padding":"10px","borderRadius":"4px","boxShadow":"0px 1px 6px #7784945e"}}>
              <span style={{fontWeight:'bold'}}>Are you an AdThrive Publisher?</span>
              <p style={{marginTop: '10px', marginBottom: '0'}}>
                Watch <a href="https://vimeo.com/594907722" target="_blank">this short video</a> to learn how to use this plugin with your AdThrive account.
              </p>
            </div>
          </Grid>
        </Grid>
    );

}

export default LoginAdthriveForm;